<!-- <div [id]="addId()">
  
</div> -->
<div id="dropin-container" class="hide_btn"></div>
<!-- <button *ngIf="type == 'payment'" id="submit-button" class="btn btn-primary btn-block">Request Payment</button> -->
<button *ngIf="type == 'addDetails'" id="submit-button" class="btn btn-primary btn-block hide_btn">Add Card Details</button>